import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import UsaReqMain from "./UsaReqMain";
const UsaReq = () => {
  return (
    <div className="uaeReqContainer">
      <UsaReqMain />
    </div>
  );
};

export default UsaReq;
